import React, {Component} from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';

function mapStateToProps(state) {
   return {
    user: state.user.data
  };
}

function mapDispatchToProps(dispatch) {
  return {
  }
}

class Profile extends Component {

  render() {
    const { user } = this.props;

    return (
      <div className="Profile">
        <div className="column-center column-m center">
          <h2>Profile</h2>
          <p>{user.username}</p>
          <p>Joined {user.createdAt}</p>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile);



// WEBPACK FOOTER //
// ./src/views/Profile/Profile.js